
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.396 25.91h2.679l3.202 5.79h.128l3.202-5.79h2.678l-4.762 8.207V39h-2.365v-4.883l-4.762-8.208zm15.921 13.282c-.959 0-1.79-.211-2.493-.633a4.297 4.297 0 01-1.636-1.77c-.383-.76-.575-1.645-.575-2.66 0-1.014.192-1.902.575-2.665a4.289 4.289 0 011.636-1.777c.703-.422 1.534-.633 2.493-.633.96 0 1.79.21 2.493.633a4.247 4.247 0 011.63 1.777c.388.763.582 1.651.582 2.665 0 1.015-.194 1.9-.582 2.66a4.255 4.255 0 01-1.63 1.77c-.703.422-1.534.633-2.493.633zm.013-1.854c.52 0 .955-.143 1.304-.428.35-.29.61-.678.78-1.164a4.77 4.77 0 00.262-1.623c0-.601-.087-1.144-.262-1.63-.17-.49-.43-.88-.78-1.17-.35-.29-.784-.434-1.304-.434-.533 0-.976.144-1.33.434-.349.29-.611.68-.786 1.17a4.901 4.901 0 00-.255 1.63c0 .596.085 1.138.255 1.623.175.486.437.874.787 1.164.353.285.796.428 1.33.428zm12.914-2.467v-5.69h2.313V39h-2.243v-1.745h-.102c-.222.55-.586 1-1.093 1.349-.503.35-1.123.524-1.86.524-.644 0-1.213-.143-1.707-.428-.49-.29-.874-.71-1.15-1.26-.278-.554-.416-1.223-.416-2.007v-6.251H40.3v5.893c0 .622.17 1.117.511 1.483.341.367.788.55 1.342.55.341 0 .672-.083.991-.25.32-.165.582-.413.786-.74.21-.333.314-.749.314-1.247z","fill":"#fff"}})])
          )
        }
      }
    